




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

import ClientDealsSchedulingForm from '../../ClientDealsSchedulingForm/ClientDealsSchedulingForm.vue';

export const CONTACTS_LIST = 'CONTACTS_LIST';
export const DELIVERY_POINT_LIST = 'DELIVERY_POINT_LIST';
export const COUNTERPARTIE_LIST = 'COUNTERPARTIE_LIST';

@Component
export default class ClientDealScheduling extends Vue {

  @Prop() clientId!: string;

  meta = {};
  documents = [];
  loading = false;

  loadData() {
    this.loading = true;

    (this as any).$db([
      (this as any).$q(CONTACTS_LIST)
        .select()
        .fileds({
          id: 'client_deals_schedule.id',
          weekday: 'client_deals_schedule.weekday',
          delivery_point_address: 'delivery_points.address',
          contact_name: 'people.name',
          contact_phone: 'people.primary_phone',
          archived_at: 'client_deals_schedule.archived_at',
          is_strict: 'client_deals_schedule.is_strict',
          with_address: 'client_deals_schedule.with_address'
        })
        .from('client_deals_schedule')
        .leftJoin('people', (_: any) => {
          return _.eq('client_deals_schedule.person_id', 'people.id');
        })
        .leftJoin('delivery_points', (_: any) => {
          return _.eq('client_deals_schedule.delivery_point_id', 'delivery_points.id');
        })
        .limit(10000)
        .where((_: any) => {
          return _.eq(`client_deals_schedule.client_id`, _.const(this.clientId));
        })
    ]).then((result: ServerResult) => {
      const opResult = result.getOperation(CONTACTS_LIST).getContent();

      this.meta = fetchEnumsFromSchema(opResult.schema)
      this.documents = opResult.documents

    }).finally(() => {
      this.loading = false;
    });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: ClientDealsSchedulingForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          client_id: this.clientId
        }
      },
      events: {
        'form-close': () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}

